import { useExternalScript, useExternalStyle } from '@allesauto/utils/hooks';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

interface ConfiguratorProps {
  errorHandler?: () => void;
  scriptURL: string;
  stylesURL: string;
  makeNameCdSysteme: string;
  modelName: string;
  trim: string;
  handleConfigurationFinished: () => void;
  bodyDesign: string;
}

const Configurator = ({
  errorHandler,
  scriptURL,
  stylesURL,
  makeNameCdSysteme,
  modelName,
  trim,
  bodyDesign,
  handleConfigurationFinished,
}: ConfiguratorProps) => {
  const [isLoading, hasError] = useExternalScript(scriptURL);
  useExternalStyle(stylesURL);
  const router = useRouter();
  const configuratorId = 'alles-auto';

  if (isLoading && hasError) {
    errorHandler && errorHandler();
  }

  useEffect(() => {
    if (isLoading) return;
    const configuratorContainer = document.getElementById(configuratorId);
    if (!configuratorContainer) return;

    function eventListenerFunction(e: any) {
      const configurationId = e.detail.configuration_id;

      if (!configurationId) return;
      handleConfigurationFinished();
      router.replace(
        {
          pathname: router.asPath.split('?')[0],
          query: {
            configuratorId: configurationId,
          },
        },
        undefined,
        { shallow: true }
      );
    }

    window.addEventListener('CONFIGURATION_FINISHED', eventListenerFunction);

    return () => {
      window.removeEventListener(
        'CONFIGURATION_FINISHED',
        eventListenerFunction
      );
    };
  }, [isLoading]);

  return (
    <div
      id="cd-configurator"
      // data-privacypolicy="https://www.emilfrey.de/datenschutz"
      data-auth={process.env.NEXT_PUBLIC_CONFIGURATOR_AUTH}
      data-make={makeNameCdSysteme}
      data-model={modelName}
      data-trim={trim}
      data-bodydesign={bodyDesign}
    ></div>
  );
};

export default Configurator;
